<ol class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs ; let last = last" class="breadcrumb-item">
    <ng-container *ngIf="!last; else lastItem">
      <a *ngIf="breadcrumb.url !== '/'" [routerLink]="[breadcrumb.url]">
        <ng-container *ngIf="breadcrumb.raw; else translatedLink">{{ breadcrumb.label }}</ng-container>
        <ng-template #translatedLink>
          {{'core.components.breadcrumb.' + transformTranslationPath(breadcrumb.label) | translate}}
        </ng-template>
      </a>
      <a *ngIf="breadcrumb.url === '/'" [routerLink]="[breadcrumb.url]"><i class="fa fa-home" aria-hidden="true"></i></a>
    </ng-container>
    <ng-template #lastItem>
      <span>
        <ng-container *ngIf="breadcrumb.raw; else translatedLast">{{ breadcrumb.label }}</ng-container>
        <ng-template #translatedLast>
          {{'core.components.breadcrumb.' + transformTranslationPath(breadcrumb.label) | translate}}
        </ng-template>
      </span>
    </ng-template>
  </li>
  <ng-container *ngIf="breadcrumbs.length === 0">
    <li class="breadcrumb-item">
      <a [routerLink]="['dashboard']"><i class="fa fa-home" aria-hidden="true"></i></a>
    </li>
    <li class="breadcrumb-item">
      <span>{{'core.components.breadcrumb.companies'|translate}}</span>
    </li>
  </ng-container>
</ol>
